import { render } from "./CombinationsCheckDetailsModal.vue?vue&type=template&id=8036c3fa"
import script from "./CombinationsCheckDetailsModal.vue?vue&type=script&lang=js"
export * from "./CombinationsCheckDetailsModal.vue?vue&type=script&lang=js"

import "./CombinationsCheckDetailsModal.vue?vue&type=style&index=0&id=8036c3fa&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QRadio,QCheckbox});
